// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post } from "./api_client";
import { VersionReport, IVersionReport } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function latestByDeviceId(deviceId?: string): ApiResult<VersionReport> {
	return get<IVersionReport>(`/api/version/current/${ deviceId }`).then(result => result === undefined ? undefined :  new VersionReport(result));
}

export async function updateDevice(deviceId?: string, packages?: string[]): ApiResult<undefined> {
	return post(`/api/version/current/${ deviceId }`, packages);
}
